import { useState } from 'react';

import { AddContactForm } from './AddContact/AddContactForm';
import { CurrentReferenceCreatePane, ReferencePaneProps } from '../../types/referenceTypes';
import { Reference } from 'types';
import { ReferenceCreateLandingPage } from './LandingPage/ReferenceCreateLandingPage';
import { candidateFeedbackToasts, HiringRequestToast } from '../../enums';

export const ReferencePane: React.FC<ReferencePaneProps> = ({
  candidateId,
  candidateName,
  hiringRequestId,
  onCancel,
  setFeedbackModalToast,
}) => {
  const [currentReferencePane, setCurrentReferencePane] =
    useState<CurrentReferenceCreatePane>('landingPage');
  const [newReferenceContact, setNewReferenceContact] = useState<Reference>(null);

  const handleNewReferenceContactClick = () => setCurrentReferencePane('addContact');
  const handleSetNewContact = (reference: Reference) => setNewReferenceContact(reference);

  const handleBackClick = (reference: Reference) => {
    setFeedbackModalToast({
      type: HiringRequestToast.SUCCESS,
      message: candidateFeedbackToasts.referenceContact,
    });
    setCurrentReferencePane('landingPage');
    setNewReferenceContact(reference);
  };

  return (
    <>
      {currentReferencePane === 'landingPage' && (
        <ReferenceCreateLandingPage
          candidateName={candidateName}
          candidateId={candidateId}
          newReferenceContact={newReferenceContact}
          onAddClick={handleNewReferenceContactClick}
          onCancel={onCancel}
          hiringRequestId={hiringRequestId}
          setFeedbackModalToast={setFeedbackModalToast}
        />
      )}
      {currentReferencePane === 'addContact' && (
        <AddContactForm
          candidateId={candidateId}
          onBackClick={handleBackClick}
          onCancel={onCancel}
          handleSetNewContact={handleSetNewContact}
          candidateName={candidateName}
        />
      )}
    </>
  );
};
